export type SearchSectionKey =
	| 'artists'
	| 'editions'
	| 'primary'
	| 'nfts'
	| 'books'
	| 'merch'
	| 'talks'
	| 'podcasts';

// One search everywhere, but ranked for where you are: the section you are
// browsing surfaces its own results first, with the default order after.
const CONTEXT_PRIORITIES: [string[], SearchSectionKey[]][] = [
	[
		['/shop', '/merch', '/publishing'],
		['books', 'merch'],
	],
	[['/editions'], ['editions']],
	[['/primary'], ['primary']],
	[['/nft'], ['nfts']],
	[['/talks'], ['talks', 'podcasts']],
	[['/artworks'], ['artists', 'editions', 'primary']],
	[['/artists'], ['artists']],
];

export const getSectionPriority = (pathname: string): SearchSectionKey[] => {
	const match = CONTEXT_PRIORITIES.find(([prefixes]) =>
		prefixes.some(
			(prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
		)
	);

	return match?.[1] || [];
};
